import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';

import { Attachment } from '../../../shared/models/attachment.model';

@Component({
  selector: 'reason-form-attachment',
  template: `
    <div class="answer-wrapper">
      <attachment 
        [attachments]="filesToUpload" 
        (attachmentsChange)="updateAnswer($event)">
      </attachment>
    </div>
  `,
})

export class ReasonFormAttachmentComponent implements OnChanges {
  @Input() question: any;
  @Input() answer: any;
  @Output() validationChange = new EventEmitter();

  filesToUpload: Array<Attachment>;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['question']) {
      this.filesToUpload = [];
    }
  }

  updateAnswer(attachments: Attachment[]): void {
    this.answer.attachmentIds = _.map(attachments, attachment => attachment.id);
    this.validationChange.emit(this.answer.attachmentIds.length > 0);
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/reasons/reason-form/reason-form-attachment.component.ts